import { Injectable } from '@angular/core';
import { Observable, ReplaySubject } from 'rxjs';

import { User, UserOidc } from '../models';

const userSubject: ReplaySubject<User> = new ReplaySubject(1);

@Injectable({
    providedIn: 'root'
})
export class UserService {
    private userSubject: ReplaySubject<User | UserOidc | undefined> = new ReplaySubject(1);
    currentUser$ = this.userSubject.asObservable();

    constructor() {
        this.user = {
            id: '123',
            firstName: 'Valerie',
            lastName: 'Luna',
            email: 'vluna@aol.com',
            image: '/assets/img/illustrations/profiles/profile-1.png',
        };
        // Initialize with no user
        this.userSubject.next(undefined);
    }

    /**
     * Sets a new user
     */
    set user(user: User | UserOidc) {
        this.userSubject.next(user);
    }

    /**
     * Clears the stored user data
     */
    clearUser(): void {
        this.userSubject.next(undefined);
    }

    get user$(): Observable<User> {
        return userSubject.asObservable();
    }
}
